<template>
  <div class="form-wrapper" id="form-container">
    <StepOne v-if="currentStep === 1" @next="nextStep" :formData="formData" @update="updateFormData"/>
    <StepTwo v-if="currentStep === 2" @next="nextStep" @previous="previousStep" :formData="formData" @update="updateFormData"/>
    <StepThree v-if="currentStep === 3" @next="nextStep" @previous="previousStep" :formData="formData" @update="updateFormData"/>
    <StepFour v-if="currentStep === 4" @next="nextStep" @form-submitted="handleFormSubmitted" @previous="previousStep" :formData="formData" @update="updateFormData"/>
    <StepFive v-if="currentStep === 5" @next="nextStep" @previous="previousStep" :formData="formData" @update="updateFormData"/>
    <StepSix v-if="currentStep === 6" @form-submitted="handleFormSubmitted" @previous="previousStep" :formData="formData" @update="updateFormData"/>
  </div>
</template>

<script>
import StepOne from './MultiStepFormChildren/FormStep1.vue';
import StepTwo from './MultiStepFormChildren/FormStep2.vue';
import StepThree from './MultiStepFormChildren/FormStep3.vue';
import StepFour from "./MultiStepFormChildren/FormStep4.vue";
import StepFive from "./MultiStepFormChildren/FormStep5.vue";
import StepSix from "./MultiStepFormChildren/FormStep6.vue";

export default {
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
    StepFive,
    StepSix
  },
  data() {
    return {
      // Definiere deine Daten und Initialwerte hier
      currentStep: 1,
      formData: {
        // Initialisiere deine Formulardaten hier
      },
      stepsData: null,
    };
  },
  created() {
    this.initializeSteps();
  },
  methods: {
    initializeSteps() {
      let storedStepsData = this.$cookies.get('stepsData');
      if (storedStepsData?.transport && storedStepsData?.firstName && storedStepsData?.avatar) {
        this.formData.avatar = storedStepsData.avatar;
        this.formData.transport = storedStepsData.transport;
        this.formData.firstName = storedStepsData.firstName;
        this.$emit('form-submitted', this.formData);
      }
    },
    nextStep() {
      this.currentStep++;
      this.$emit('sendCurrentStep',this.currentStep);
    },
    previousStep() {
      this.currentStep--;
      this.$emit('sendCurrentStep',this.currentStep);

    },
    updateFormData(updatedData) {
      this.formData = { ...this.formData, ...updatedData };
      // Speichere aktualisierte formData im Cookie
      this.$cookies.set('stepsData', this.formData);
    },
    handleFormSubmitted() {
      // Hier könntest du zusätzliche Logik hinzufügen, wenn das Formular eingereicht wird
      this.$emit('form-submitted', this.formData);
    }
  }
}
</script>

<style lang="scss">
@import 'src/assets/css/components/multistepform';
</style>

<style lang="scss" scoped>
@media screen and (max-width: 640px) {
  footer {
    position:relative;
  }

  body {
    overflow:scroll;
  }
}
</style>